import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { JourneySectionHelperService } from '../../services/journey-section-helper.service';
import { LocaleService } from '../../services/locale.service';

type StepState = 'default' | 'active' | 'completed';

type PostInitialCopy = {
  title: string;
  highlightedText: string;
  description: string;
  buttonText: string;
  steps: { label: string; state: StepState }[];
};

const postInitialCopy: Record<string, PostInitialCopy> = {
  en: {
    title: 'You are ready to continue your',
    highlightedText: 'life-saving journey!',
    description:
      'The next questionnaire will take a closer look at your health and lifestyle to confirm your eligibility.',
    buttonText: 'Get Started',
    steps: [
      { label: 'Initial Questionnaire', state: 'completed' },
      { label: 'Comprehensive Questionnaire', state: 'default' },
      { label: 'Living Kidney Donor Consent', state: 'default' },
      { label: 'Consultation & Evaluation', state: 'default' },
    ],
  },
  es: {
    title: 'Está listo para continuar su',
    highlightedText: 'camino para salvar vidas.',
    description:
      'El siguiente cuestionario analizará más de cerca su salud y estilo de vida para confirmar su elegibilidad.',
    buttonText: 'Comenzar',
    steps: [
      { label: 'Cuestionario Inicial', state: 'completed' },
      { label: 'Cuestionario Completo', state: 'default' },
      { label: 'Consentimiento para Donante Vivo de Riñón', state: 'default' },
      { label: 'Consulta y Evaluación', state: 'default' },
    ],
  },
};

@Component({
  selector: 'app-post-initial-screen',
  templateUrl: './post-initial-screen.component.html',
  styleUrl: './post-initial-screen.component.scss'
})
export class PostInitialScreenComponent implements OnInit {
  loading: boolean = false;
  sections: any[] = [];

  get copy() {
    return (
      postInitialCopy[
        this.localeService.currentLocale as keyof typeof postInitialCopy
      ] || postInitialCopy['en']
    );
  }

  constructor(private journeyHelper: JourneySectionHelperService, private router: Router,
    private locationStrategy: LocationStrategy,
    private localeService: LocaleService){}
  ngOnInit(): void {
    this.journeyHelper.ensureJourneySectionsExist().subscribe({
      next: (sections)=>{
        this.sections = sections;
      }
    })
    
  }

  handleButtonClick() {
    this.loading = true;
    this.journeyHelper.updateSectionStatus(this.sections[1].sectionId, "In Progress").subscribe({
      next: (res)=>{
       
        this.router.navigate(['/questionnaire/cquestionnaire']).then(() => {
          this.locationStrategy.replaceState({}, '', '/questionnaire/cquestionnaire', '');
          this.loading = false;
        });
      }
    });
  }

}
